'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
import React from 'react';
import { findClosestGlyphAvailable, Icon, IconSizeMap } from "../../index.mjs";
export function IconTextUnderline(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M5.417 7.288V1h-1.5v6.288c0 1.18.458 2.166 1.228 2.85.76.675 1.779 1.017 2.855 1.017s2.095-.342 2.855-1.017c.77-.684 1.228-1.67 1.228-2.85V1h-1.5v6.288c0 .768-.288 1.34-.724 1.728-.446.396-1.094.639-1.86.639-.764 0-1.412-.243-1.858-.639-.437-.388-.724-.96-.724-1.728zM3 15h10v-1.5H3V15z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M9 11.546V4H7v7.546c0 1.442.561 2.654 1.508 3.494.933.829 2.18 1.246 3.492 1.246 1.312 0 2.56-.417 3.492-1.246C16.44 14.2 17 12.988 17 11.546V4h-2v7.546c0 .894-.334 1.553-.836 1.998-.514.457-1.267.742-2.164.742-.897 0-1.65-.284-2.164-.742C9.334 13.1 9 12.44 9 11.546zM6 18v2h12v-2H6z\'/>'
  }];
  var iconSizeValue = props.size ? IconSizeMap[props.size] : props.iconSize;
  var closestSize = findClosestGlyphAvailable(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconTextUnderline is deprecated and will be archived soon. Use IconTextUnderline instead.
 */
export function Experimental__IconTextUnderline(props) {
  return /*#__PURE__*/React.createElement(IconTextUnderline, props);
}